document.addEventListener("DOMContentLoaded", function () {
    const selectors = {
        slideshow: "[data-slideshow]",
        speed: 500,
    };

    const sectionId = '[data-section-type="product-slideshow"] .swiper-container';

    // Show loading state for DY content
    function showLoadingState() {
        document.querySelectorAll(".swiper-slide").forEach((slide) => {
            const spinner = slide.querySelector(".loading-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show spinner while waiting for DY
            }
        });
    }

    // Remove loading state once content is loaded
    function removeLoadingState() {
        document.querySelectorAll(".swiper-slide").forEach((slide) => {
            const spinner = slide.querySelector(".loading-spinner");
            if (spinner) {
                spinner.style.display = "none"; // Hide spinner once DY content is loaded
            }
        });
    }

    // Wait for an element to exist
    function waitForElement(selector, callback, interval = 100, timeout = 10000) {
        const startTime = new Date().getTime();

        const checkExist = setInterval(() => {
            const element = document.querySelector(selector);
            const elapsed = new Date().getTime() - startTime;

            if (element) {
                clearInterval(checkExist);
                removeLoadingState(); // Remove loading once content is available
                callback();
            } else if (elapsed > timeout) {
                clearInterval(checkExist);
                console.error("Timeout: DY components did not load in time.");
            }
        }, interval);
    }

    // Add fallback spinner
    showLoadingState();

    waitForElement(
        sectionId,
        () => {
            const slideshow = document.querySelector(selectors.slideshow);

            const swiperOptions = {
                loop: true,
                observer: true,
                threshold: 8,
                speed: selectors.speed,
                slidesPerView: 4, // Default for larger screens (Desktop)
                slidesPerGroup: 1,
                spaceBetween: 40, // Adjust spacing for larger screens
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: document.querySelector(".arrow--right"),
                    prevEl: document.querySelector(".arrow--left"),
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    360: {
                        slidesPerView: 2, // 1 slide for very small mobile screens (360px+)
                        spaceBetween: 20,
                    },
                    550: {
                        slidesPerView: 2, // 2 slides for larger mobile (550px+)
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2, // 3 slides for Tablets (768px+)
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 4, // 4 slides for desktop (992px+)
                        spaceBetween: 40,
                    },
                },
                watchSlidesVisibility: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                on: {
                    init: () => {
                        document.querySelectorAll(".swiper-slide").forEach((slide) => {
                            slide.setAttribute(
                                "aria-hidden",
                                !slide.classList.contains("swiper-slide-visible")
                            );
                        });
                    },
                },
            };

            const dySwiper = new Swiper(slideshow, swiperOptions);

            dySwiper.on("slideChange", () => {
                document.querySelectorAll(".swiper-slide").forEach((slide) => {
                    slide.setAttribute(
                        "aria-hidden",
                        !slide.classList.contains("swiper-slide-visible")
                    );
                });
            });

            // Trigger a custom event to render product tiles
            const event = new Event("renderProductTiles");
            window.dispatchEvent(event);

            slideshow.setAttribute("tabindex", 0);

            // Handle focusin and focusout events
            document.addEventListener("focusin", (e) => {
                if (e.target.closest(".swiper-container")) {
                    dySwiper.autoplay.stop();
                }
            });

            document.addEventListener("focusout", (e) => {
                if (e.target.closest(".swiper-container")) {
                    dySwiper.autoplay.start();
                }
            });

            // Handle play-pause button
            const originalToggleButton =
                slideshow.querySelector(".play-pause-toggle");
            if (originalToggleButton) {
                const toggleButton = originalToggleButton.cloneNode(true);
                toggleButton.setAttribute("aria-label", "carousel pause / resume");
                toggleButton.setAttribute("tabindex", "0");
                toggleButton.classList.add("play");
                originalToggleButton.remove();
                slideshow.querySelector(".swiper-pagination").prepend(toggleButton);

                toggleButton.addEventListener("click", () => {
                    if (toggleButton.classList.contains("play")) {
                        toggleButton.classList.remove("play");
                        toggleButton.classList.add("pause");
                        dySwiper.autoplay.stop();
                    } else {
                        toggleButton.classList.remove("pause");
                        toggleButton.classList.add("play");
                        dySwiper.autoplay.start();
                    }
                });
            }
        },
        100,
        10000
    );

    // Handle custom event
    window.addEventListener("renderProductTiles", function (e) {
        renderProductTiles(e.detail);
    });
});

/**
 * Provided a selector or Node, this utility will render a
 * Preact ProductTile for each child found with a [data-product-card]
 * attribute.
 * @param {String, Node} container - either a CSS selector or an HTML node
 */
function renderProductTiles() {
    const cards = Array.from(
        document.querySelectorAll("[data-product-card]")
    ).filter((el) => el.dataset.productCard);

    cards.forEach((el) => {
        const url = el.dataset.productCard;
        let handle = url;

        if (url.indexOf("products/") > 0) {
            handle = url.split("products/")[1];
        }

        if (handle) {
            // Fetch HTML content for the product card
            fetch(`/products/${handle}?view=product-card`)
                .then((response) => {
                    // Check if the request was successful
                    if (!response.ok) {
                        console.warn(`Product not found: ${handle}`);
                        const slide = el.closest(".swiper-slide"); // Find the closest swiper-slide
                        if (slide) slide.remove(); // Remove the entire swiper-slide element on error
                        return null;
                    }
                    return response.text();
                })
                .then((html) => {
                    if (html) {
                        // Append the fetched HTML to the slider element
                        el.insertAdjacentHTML("beforeend", html);

                        // Add event listeners to variant images
                        const variantImages = document.querySelectorAll(".variant-image");
                        variantImages.forEach((image) => {
                            image.addEventListener("mouseenter", handleImageHover);
                            image.addEventListener("click", handleImageClick);
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching product card HTML:", error);
                    const slide = el.closest(".swiper-slide"); // Find the closest swiper-slide
                    if (slide) slide.remove(); // Remove the entire swiper-slide element on error
                });
        }
    });
}

// Capitalize the first letter of a string
function capitalize(str) {
    return str
        .toLowerCase()
        .replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
}

// Capitalize the first letter of each word in a string
function capitalizeAll(str) {
    return str.split(" ").map(capitalize).join(" ");
}
